import { useLocation, useNavigate, useSearchParams, useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { connect } from "react-redux";
import PageSelector from '../../components/PageSelector';
import LoadingPage from "../../components/Loading";
import PageNotFound from "../PageNotFound";

const TABS = ['會員記錄','合作夥伴','交易記錄','T.Dollar儲值記錄'];

function Page(props) {
    const navigate = useNavigate();
    const { id } = useParams();
    const location = useLocation();
    const navigateTo = (str) => () => {
        navigate(str)
    }
    const [isloading, setIsloading] = useState(false)
    const [searchParams, setSearchParams] = useSearchParams();
    const [tab, setTab] = useState(TABS[0])








    return (
        <div className="relative h-full w-full flex flex-col items-start justify-start bg-[#ddd] p-[16px] gap-[16px]" style={{ overflowY: 'auto' }}>

            <div className='font-[700] p-[16px] bg-[white] rounded-[7px] w-full'>T.Shop管理 (Tgather)</div>
            <div className="w-full flex flex-row gap-[16px] flex-wrap">
                {TABS.map((item, index) =>
                    <div key={item} className="flex flex-row items-center justify-center cursor-pointer" style={{ fontWeight: item === tab ? '700' : '400', fontSize: '16px', color: item === tab ? '#000' : '#00000099', padding: '8px 16px', borderBottom: item === tab ? '2px solid #000' : 'none' }} onClick={() => { setTab(item) }}>
                        {item}
                    </div>
                )}
            </div>

            <PageNotFound/>


            {isloading && <LoadingPage />}
        </div>
    )
}


export default connect((store) => {
    return {
        token: store.tokenReducer,
        control: store.controlReducer,
    }
})(Page)
